import React, {useMemo, useState} from 'react';
import {AssignedRequirement, VehicleProject, VehicleProjectMaster} from 'types';
import {funcDecodeHex24} from 'components/InfinityList';
import {useNavigate, useParams} from 'react-router-dom';
import {
	useGetVehicleProjectRequirementsInfinityLazyQuery,
	useGetVehicleProjectRequirementsNextLazyQuery,
	useGetVehicleProjectRequirementsSortOrderLazyQuery,
} from '../hooks/AssigedRequirementsInfinity.generated';
import {ProjectDetailsPageParams} from '../vehicleProjectPagePaths';
import {GetVehicleProjectDetailsQuery} from '../hooks';
import {mapProjectRequirement} from './AssignedRequirementColumns';
import {
	AssignedRequirementsList,
	QueryDocumentsDBArg,
} from './AssignedRequirementsList';

export type VehicleProjectDetailsTabProps = {
	dataVehPro: GetVehicleProjectDetailsQuery | undefined;
	hidden: boolean;
};

const VehicleProjectDetailsTabRequirements: React.FC<
	VehicleProjectDetailsTabProps
> = ({dataVehPro, hidden}) => {
	const {modelSeries, generation} = useParams() as ProjectDetailsPageParams;

	const [getSortOrder] = useGetVehicleProjectRequirementsSortOrderLazyQuery();

	const [
		getAssignedRequirementsQuery,
		{loading: loadingQuery, data: dataQuery},
	] = useGetVehicleProjectRequirementsInfinityLazyQuery();

	const [getRequirementsNext, {loading: loadingDocuments}] =
		useGetVehicleProjectRequirementsNextLazyQuery();

	const arrIds = useMemo(
		() =>
			dataQuery?.vehicleProjectMasterRequirementsQuery?.requirementIds ?? [],
		[dataQuery],
	);

	const dictVehicleProjects: Record<string, VehicleProject> = useMemo(
		() =>
			(dataVehPro?.vehicleProjectsByModelSeriesAndGeneration ?? []).reduce(
				(acc, item) => {
					acc[funcDecodeHex24(item.id)] = item as VehicleProject;
					return acc;
				},
				{} as Record<string, VehicleProject>,
			),
		[dataVehPro],
	);

	const queryDocumentsDB = async (
		query: QueryDocumentsDBArg,
		sortField: string,
		sortOrder: string,
	) => {
		const variables = {
			queryArgAssignedRequirements: {
				modelSeries,
				generation,
				queryAssignedReq: query.queryAssignedReq,
				queryArgs: {query: query.queryReq, sortField, sortOrder},
			},
		};

		const {data: dataQuery} = await getAssignedRequirementsQuery({
			variables,
		});

		const arrDocumentNext = (
			dataQuery?.vehicleProjectMasterRequirementsQuery
				?.assignedRequirementsBatch ?? []
		).map(x => mapProjectRequirement(x as AssignedRequirement));

		const arrIDsNew =
			dataQuery?.vehicleProjectMasterRequirementsQuery?.requirementIds ?? [];
		return {arrDocumentNext, arrIDsNew};
	};

	const getDocumentsNextDB = async (preFilteredIds: string[]) => {
		const {data: dataDocumentsNext} = await getRequirementsNext({
			variables: {
				nextArgAssignedRequirements: {
					modelSeries,
					generation,
					nextArgs: {preFilteredIds},
				},
			},
		});
		return (dataDocumentsNext?.vehicleProjectMasterRequirementsNext ?? []).map(
			x => mapProjectRequirement(x as AssignedRequirement),
		);
	};

	const getSortOrderDB = async (
		preFilteredIds: string[],
		sortField: string,
	) => {
		const {data: dataSortOrder} = await getSortOrder({
			variables: {
				sortArgs: {sortField, preFilteredIds},
			},
		});

		return dataSortOrder?.requirementsSortOrder ?? [];
	};

	const requirementFilterOptions =
		dataQuery?.vehicleProjectMasterRequirementsQuery?.requirementFilterOptions;

	const assignedRequirementFilterOptions =
		dataQuery?.vehicleProjectMasterRequirementsQuery
			?.assignedRequirementFilterOptions;

	const assignedRequirementsListprops = {
		loadingQuery,
		loadingDocuments,
		hidden,
		arrIds,
		requirementFilterOptions,
		assignedRequirementFilterOptions,
		dictVehicleProjects,
		vehicleProjectMaster:
			dataVehPro?.vehicleProjectMasterByModelSeriesAndGeneration as VehicleProjectMaster,
		queryDocumentsDB,
		getDocumentsNextDB,
		getSortOrderDB,
	};

	return <AssignedRequirementsList {...assignedRequirementsListprops} />;
};
export default VehicleProjectDetailsTabRequirements;
